import axios from "axios";

export default {
  getProductList({ commit }, list) {
    commit("setLoading", true);
    return axios({
      url: `/product/list?order_by=${list.order_by || ''}&order_dir=${list.order_dir || ''}`,
      params: {
        status: list.is_active ? "active" : '',
        page: list.page ? list.page : "0",
        product_name: list.product_name ? "*" + list.product_name + "*" : "",
        per_page: list.perPage ? list.perPage : 10,
        // has_company_uuid: list.company_uuid ? list.company_uuid : "",
      },
      method: "GET",
    })
      .then((res) => {
        const { items: products, total, per_page } = res.data.payload;
        commit("setLoading", false);
        commit("SET_ALL_PRODUCTS", { products, total, per_page });
        return res.data.payload.items;
      })
      .catch((err) => {
        return err;
      });
  },
  getProduct({ commit }, product_uuid) {
    return axios({
      url: "/product/" + product_uuid,
      method: "GET",
    })
      .then((res) => {
        const { rate_table_uuid, routing_uuid } = res.data.payload;
        commit("SET_CURRENT_PRODUCT", res.data.payload);
        // commit('SET_RATE_TABLE_UUID', rate_table_uuid);
        // commit('SET_ROUTING_UUID', routing_uuid);
        return res.data.payload;
      })
      .catch((err) => {
        return err;
      });
  },
  deleteProduct(
    { commit, dispatch },
    { product_uuid, rate_table_uuid, routing_uuid }
  ) {
    return axios({
      url: "/product/" + product_uuid,
      method: "DELETE",
    }).then((res) => {
      // dispatch('rateTable/deleteRateTable', rate_table_uuid, { root: true });
      // dispatch('routing/deleteRouting', routing_uuid, { root: true })
      commit("REMOVE_PRODUCT", product_uuid);
      // return res.data.payload;
    });
  },
  editProduct({ commit }, product) {
    return axios({
      url: "/product/" + product.id,
      data: product.product,
      method: "PATCH",
    }).then((res) => {
      commit("EDIT_PRODUCT", res.data.payload);
      return res.data.payload;
    });
  },
  async addProduct({ commit }, product) {
    return axios({
      url: "/product",
      data: product,
      method: "POST",
    }).then((res) => {
      commit("SET_CURRENT_PRODUCT", res.data.payload);
    });
  },
  updateProduct({ commit }, fields) {
    commit("UPDATE_PRODUCT", fields);
  },
  addOperator({ commit }) {
    commit("ADD_OPERATOR");
  },
  updateOperator({ commit }, fields) {
    commit("UPDATE_OPERATOR", fields);
  },
  addOperators({ commit }, operators) {
    commit("SET_OPERATORS", operators);
    commit("UPDATE_ACTIVE_OPERATOR_ID", {
      operator_id: operators.length - 1,
      operator: operators[operators.length - 1],
    });
  },
  updateOperators({ commit }, operator) {
    commit("UPDATE_OPERATORS", operator);
  },
  clearOperators({ commit }) {
    commit("CLEAR_OPERATORS");
  },
  removeOperator({ commit }, index) {
    commit("REMOVE_OPERATOR", index);
  },
  chageActiveOperatorId({ commit }, params) {
    commit("UPDATE_ACTIVE_OPERATOR_ID", { ...params });
  },
  addMobileNetworkList({ commit }, { mobileNetworkList, index }) {
    commit("ADD_MOBILE_NETWORK_LIST", { mobileNetworkList, index });
  },
  removeMovileNetworkList({ commit }, index) {
    commit("DLETE_MOBILE_NETWORK_LIST", index);
  },
  addVendor({ commit }) {
    commit("ADD_VENDOR");
  },
  updateVendor({ commit }, { fields, index }) {
    commit("UPDATE_VENDOR", { fields, index });
  },
  removeVendor({ commit }, index) {
    commit("REMOVE_VENDOR", index);
  },
  setAllVendors({ commit }, { vendors, index }) {
    commit("SET_ALL_VENDORS", { vendors, index });
  },
  updateAllVendors({ commit }) {
    commit("UPDATE_ALL_VENDORS");
  },
  clearAllVendors({ commit }) {
    commit("CLEAR_ALL_VENDORS");
  },
  updateNetworkName({ commit }, networkName) {
    commit("UPDATE_NETWORK_NAME", networkName);
  },
  clearAllMObileNetworks({ commit }) {
    commit("CLEAR_ALL_MOBILE_NETWORKS");
  },
  resetProductState({ commit }) {
    commit("RESET_STATE");
  },
};
